import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_PROVIDER_SALON_LIST = 'GET_PROVIDER_SALON_LIST';
export const GET_PROVIDER_SALON_LIST_SUCCESS =
  'GET_PROVIDER_SALON_LIST_SUCCESS';
export const GET_PROVIDER_SALON_LIST_FAILURE =
  'GET_PROVIDER_SALON_LIST_FAILURE';

// Action Creators
export const fetchGetProviderSalonList = () => ({
  type: GET_PROVIDER_SALON_LIST,
});

export const fetchGetProviderSalonListSuccess = (data) => ({
  type: GET_PROVIDER_SALON_LIST_SUCCESS,
  payload: data,
});

export const fetchGetProviderSalonListFailure = (error) => ({
  type: GET_PROVIDER_SALON_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getProvidreSalonListCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetProviderSalonList(data, external));
    try {
      const response = await getMethodWithToken(url.getProviderSalonList);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetProviderSalonListSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetProviderSalonListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetProviderSalonListFailure(error.message));
    }
  };
};
